import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

/**
 * HolidayPopup
 *
 * Zeigt ein Popup für den Betriebsurlaub
 * Erscheint bei jedem Seitenaufruf erneut
 */
const HolidayPopup = () => {
    const startDate = new Date("2025-12-15T00:00:00");
    const endDate = new Date("2026-01-06T23:59:59");

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const now = new Date();

        const isWithinRange =
            now >= startDate && now <= endDate;

        if (isWithinRange) {
            setIsOpen(true);
        }

        const handleEscape = (event) => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };

        window.addEventListener("keydown", handleEscape);

        return () => {
            window.removeEventListener("keydown", handleEscape);
        };
    }, []);

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className="holiday-popup">
            <div
                className="holiday-popup__backdrop"
                onClick={() => setIsOpen(false)}
            />

            <div className="holiday-popup__modal">
                <h2>Betriebsurlaub</h2>

                <p>
                    Wir befinden uns vom <strong>15.12.</strong> bis einschließlich{" "}
                    <strong>06.01.2026</strong> im Betriebsurlaub.
                </p>

                <button onClick={() => setIsOpen(false)}>
                    Schließen
                </button>
            </div>
        </div>,
        document.body
    );
};

export default HolidayPopup;
